import React, { useMemo } from "react";
import { useApiData } from "../../hooks/useFetch.js";
import { api } from "../../api/api.js";
import StateGuard from "../StateGuard.jsx";
import PertesChart from "../charts/PertesChart.jsx";

export default function PertesTab({ baseParams, risque }) {
  const params = useMemo(() => ({ ...baseParams, risque }), [baseParams, risque]);
  const { data, loading, error } = useApiData(api.getPertes, params, {
    skip: !baseParams.idProdu || !baseParams.gridno,
  });

  return (
    <div className="diagoeau-panel">
      <h3>Impacts (pertes en pourcentage de rendement pour un risque {risque}) et répartition des aléas </h3>
      <StateGuard
        loading={loading}
        error={error}
        empty={!data || !data.total || data.total.length === 0}
        emptyMessage="Pas de données pour ce point / culture."
      >
        {data && <PertesChart data={data} risque={risque} rcp={baseParams.rcp} />}
      </StateGuard>
    </div>
  );
}